const truncatePercentValue = (percentValue: number): number => {
  const truncate = (value: number, decimals: number): number =>
    Math.trunc(value * 10 ** decimals) / 10 ** decimals;

  if (percentValue === 0) {
    return 0;
  }

  if (percentValue >= 1000) {
    return Math.trunc(percentValue);
  }

  return truncate(percentValue, 2);
};

export const formatPercents = (percentValue: number): string => {
  const truncated = truncatePercentValue(percentValue);

  if (truncated === 0) {
    return new Intl.NumberFormat('en-US', {
      style: 'percent',
      signDisplay: 'never',
      maximumFractionDigits: 0,
    }).format(0);
  }

  if (truncated >= 1000) {
    return new Intl.NumberFormat('en-US', {
      style: 'percent',
      signDisplay: 'never',
      maximumFractionDigits: 0,
    }).format(truncated / 100);
  }

  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    signDisplay: 'never',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(truncated / 100);
};
